#순회점검 이상통보서 팝업
<template v-if="show">
	<sf-modal-layout class="qms-xxl" :title="getMessage_('QWCC001432')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<popup-search :scrId="scrId" ref="popSearch" @initComp="initComp" @loadImgAll="loadImgAll"></popup-search>
				</sf-card>
			</div>
			<div class="sf-col">
				<sf-card class="border-0 bg-transparent h-100" v-if="isLoaded">
					<action-buttons :scrId="scrId" @deleteFin="() => close('delete')" @refresh="refresh"></action-buttons>
					<form-info :scrId="scrId" class="mb-2"></form-info>
					<form-apcn ref="apcnView" :scrId="scrId" class="mb-2"></form-apcn>
					<form-altr ref="altrView" :scrId="scrId" class="mb-2"></form-altr>
					<form-vrf :scrId="scrId"></form-vrf>
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import _ from 'lodash';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourStts/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import ActionButtons from './PopupContent/ActionButtons.vue';
import PopupSearch from './PopupContent/PopupSearch.vue';
import FormApcn from './PopupContent/FormApcn.vue';
import FormInfo from './PopupContent/FormInfo.vue';
import FormAltr from './PopupContent/FormAltr.vue';
import FormVrf from './PopupContent/FormVrf.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false,
			isLoaded: false
		};
	},
	components: { ActionButtons, PopupSearch, FormApcn, FormInfo, FormAltr, FormVrf },
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		async open(row) {
			this.$sf_toggleLoading(true);
			this.isLoaded = false;
			this.setPopupInit_();
			this.show = true;
			this.setState_({ key: 'isSaved', value: false });
			try {
				await this.loadCommCodes();
				this.setState_({ key: 'isPqyStaff', value: await this.inclManyUsrGrp_(['PQYRG', 'OS']) }); //PQYRG 생산품질 업무담당자(작성)
				this.setState_({ key: 'isPqyReviewer', value: await this.inclManyUsrGrp_(['PQYRV', 'OS']) }); //PQYRV 생산품질 중간관리자(검토)
				this.setState_({ key: 'isPqyAdmin', value: await this.inclManyUsrGrp_(['PQYAP', 'OS']) }); //PQYAP 생산품질 관리자(승인)
				this.setState_({ key: 'isPqyLs', value: await this.inclManyUsrGrp_(['PQYLS', 'OS']) }); 

				if (!(this.isPqyStaff || this.isPqyReviewer || this.isPqyAdmin ||this.isPqyLs)) {
					throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				}

				if (row) {
					const { powLnCd, ngPrvsCt, insnDd, ipnNos, powBttmInfmNo, newInsnDd, newIpnNos, powLnNm } = row;
					if (powBttmInfmNo) {
						this.setPopupSearchParams_({ key: 'powBttmInfmNo', value: powBttmInfmNo });
						await this.getOne_();
						this.setPopupSearchParams_({ key: 'ipnNos', value: ipnNos || newIpnNos });
						this.setPopupSearchParams_({ key: 'insnDd', value: insnDd || newInsnDd });
						this.setPopupSearchParams_({ key: 'powLnCd', value: powLnCd });
					} else {
						this.setPopupSearchParams_({ key: 'ipnNos', value: ipnNos || newIpnNos });
						this.setPopupSearchParams_({ key: 'insnDd', value: insnDd || newInsnDd });
						this.setPopupSearchParams_({ key: 'powLnCd', value: powLnCd });
						this.setDetailForm_({ key: 'powLnCd', value: powLnCd });
						this.setDetailForm_({ key: 'insnDd', value: insnDd || newInsnDd });
						this.setDetailForm_({ key: 'ipnNos', value: ipnNos || newIpnNos });
						this.setDetailForm_({ key: 'incsPrvsIct', value: ngPrvsCt });
						await this.getSearchOne_();
					}
					this.setDetailForm_({ key: 'powLnNm', value: _.find(this.powLnList, { value: powLnCd })?.label });
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaved', value: false });
				this.isLoaded = true;
				this.$sf_toggleLoading(false);
			}
		},
		close() {
			this.$emit('Refresh');
			this.setPopupInit_();
			this.show = false;
			this.isLoaded = false;
		},
		async loadCommCodes() {
			await this.getCommCodes_({ key: 'sndStList', codeType: 'SND_ST' });
			await this.getCommCodes_({ key: 'powLnList', codeType: 'OCCU_PL' });
			await this.getCommCodes_({ key: 'mdvRplList', codeType: 'MDV_RPL' });
			await this.getCommCodes_({ key: 'pgsStList', codeType: 'PGS_ST_PT' });
		},
		async refresh() {
			try {
				this.isLoaded = false;
				this.setPopupInit_();
				this.initComp();
				await this.getOne_();
				this.loadImgAll();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.isLoaded = true;
			}
		},
		loadImgAll() {
			this.initComp();
			this.$refs.altrView?.loadImg(); //이미지 재로딩 (mounted 이후에 blob 주소 가져오기)
		},
		initComp() {
			//별도의 컴포넌트가 있는 항목들의 개별 초기화
			this.$refs.altrView?.initImgAll(); //이미지 초기화
			this.$refs.apcnView?.setupEmail(); //이메일 부분 초기화
		}
	},

	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	}
};
</script>
